import React, { useState } from "react";
import styles from "./PublicFormLayout.module.scss";
import LandingPageHeader from "../public-layout-landing/components/LandingPageHeader";
import PublicSideMenu from "../components/public-side-menu/PublicSideMenu";
import { Outlet } from "react-router-dom";
import CopyrightFooter from "../components/copyright-footer/CopyrightFooter";

type Props = {};

const PublicFormLayout: React.FC<Props> = (props: Props) => {
	const [menuOpen, setMenuOpen] = useState(false);

	function handleMenuButtonClick() {
		setMenuOpen(!menuOpen);
	}

	return (
		<>
			<div className={styles.container}>
				<div className={styles.background} />
				<div className={styles.content}>
					<LandingPageHeader onMenuButtonClick={handleMenuButtonClick} />
					<Outlet />
				</div>
				<div className={styles.footerContainer}>
					<CopyrightFooter />
				</div>
			</div>
			<PublicSideMenu menuOpen={menuOpen} closeMenu={handleMenuButtonClick} />
		</>
	);
};

export default PublicFormLayout;
